export const emojiNative = [
  '🀄',
  '🃏',
  '🅰',
  '🅱',
  '🅾',
  '🅿',
  '🆎',
  '🆑',
  '🆒',
  '🆓',
  '🆔',
  '🆕',
  '🆖',
  '🆗',
  '🆘',
  '🆙',
  '🆚',
  '🇦🇨',
  '🇦🇩',
  '🇦🇪',
  '🇦🇫',
  '🇦🇬',
  '🇦🇮',
  '🇦🇱',
  '🇦🇲',
  '🇦🇴',
  '🇦🇶',
  '🇦🇷',
  '🇦🇸',
  '🇦🇹',
  '🇦🇺',
  '🇦🇼',
  '🇦🇽',
  '🇦🇿',
  '🇦',
  '🇧🇦',
  '🇧🇧',
  '🇧🇩',
  '🇧🇪',
  '🇧🇫',
  '🇧🇬',
  '🇧🇭',
  '🇧🇮',
  '🇧🇯',
  '🇧🇱',
  '🇧🇲',
  '🇧🇳',
  '🇧🇴',
  '🇧🇶',
  '🇧🇷',
  '🇧🇸',
  '🇧🇹',
  '🇧🇻',
  '🇧🇼',
  '🇧🇾',
  '🇧🇿',
  '🇧',
  '🇨🇦',
  '🇨🇨',
  '🇨🇩',
  '🇨🇫',
  '🇨🇬',
  '🇨🇭',
  '🇨🇮',
  '🇨🇰',
  '🇨🇱',
  '🇨🇲',
  '🇨🇳',
  '🇨🇴',
  '🇨🇵',
  '🇨🇷',
  '🇨🇺',
  '🇨🇻',
  '🇨🇼',
  '🇨🇽',
  '🇨🇾',
  '🇨🇿',
  '🇨',
  '🇩🇪',
  '🇩🇬',
  '🇩🇯',
  '🇩🇰',
  '🇩🇲',
  '🇩🇴',
  '🇩🇿',
  '🇩',
  '🇪🇦',
  '🇪🇨',
  '🇪🇪',
  '🇪🇬',
  '🇪🇭',
  '🇪🇷',
  '🇪🇸',
  '🇪🇹',
  '🇪🇺',
  '🇪',
  '🇫🇮',
  '🇫🇯',
  '🇫🇰',
  '🇫🇲',
  '🇫🇴',
  '🇫🇷',
  '🇫',
  '🇬🇦',
  '🇬🇧',
  '🇬🇩',
  '🇬🇪',
  '🇬🇫',
  '🇬🇬',
  '🇬🇭',
  '🇬🇮',
  '🇬🇱',
  '🇬🇲',
  '🇬🇳',
  '🇬🇵',
  '🇬🇶',
  '🇬🇷',
  '🇬🇸',
  '🇬🇹',
  '🇬🇺',
  '🇬🇼',
  '🇬🇾',
  '🇬',
  '🇭🇰',
  '🇭🇲',
  '🇭🇳',
  '🇭🇷',
  '🇭🇹',
  '🇭🇺',
  '🇭',
  '🇮🇨',
  '🇮🇩',
  '🇮🇪',
  '🇮🇱',
  '🇮🇲',
  '🇮🇳',
  '🇮🇴',
  '🇮🇶',
  '🇮🇷',
  '🇮🇸',
  '🇮🇹',
  '🇮',
  '🇯🇪',
  '🇯🇲',
  '🇯🇴',
  '🇯🇵',
  '🇯',
  '🇰🇪',
  '🇰🇬',
  '🇰🇭',
  '🇰🇮',
  '🇰🇲',
  '🇰🇳',
  '🇰🇵',
  '🇰🇷',
  '🇰🇼',
  '🇰🇾',
  '🇰🇿',
  '🇰',
  '🇱🇦',
  '🇱🇧',
  '🇱🇨',
  '🇱🇮',
  '🇱🇰',
  '🇱🇷',
  '🇱🇸',
  '🇱🇹',
  '🇱🇺',
  '🇱🇻',
  '🇱🇾',
  '🇱',
  '🇲🇦',
  '🇲🇨',
  '🇲🇩',
  '🇲🇪',
  '🇲🇫',
  '🇲🇬',
  '🇲🇭',
  '🇲🇰',
  '🇲🇱',
  '🇲🇲',
  '🇲🇳',
  '🇲🇴',
  '🇲🇵',
  '🇲🇶',
  '🇲🇷',
  '🇲🇸',
  '🇲🇹',
  '🇲🇺',
  '🇲🇻',
  '🇲🇼',
  '🇲🇽',
  '🇲🇾',
  '🇲🇿',
  '🇲',
  '🇳🇦',
  '🇳🇨',
  '🇳🇪',
  '🇳🇫',
  '🇳🇬',
  '🇳🇮',
  '🇳🇱',
  '🇳🇴',
  '🇳🇵',
  '🇳🇷',
  '🇳🇺',
  '🇳🇿',
  '🇳',
  '🇴🇲',
  '🇴',
  '🇵🇦',
  '🇵🇪',
  '🇵🇫',
  '🇵🇬',
  '🇵🇭',
  '🇵🇰',
  '🇵🇱',
  '🇵🇲',
  '🇵🇳',
  '🇵🇷',
  '🇵🇸',
  '🇵🇹',
  '🇵🇼',
  '🇵🇾',
  '🇵',
  '🇶🇦',
  '🇶',
  '🇷🇪',
  '🇷🇴',
  '🇷🇸',
  '🇷🇺',
  '🇷🇼',
  '🇷',
  '🇸🇦',
  '🇸🇧',
  '🇸🇨',
  '🇸🇩',
  '🇸🇪',
  '🇸🇬',
  '🇸🇭',
  '🇸🇮',
  '🇸🇯',
  '🇸🇰',
  '🇸🇱',
  '🇸🇲',
  '🇸🇳',
  '🇸🇴',
  '🇸🇷',
  '🇸🇸',
  '🇸🇹',
  '🇸🇻',
  '🇸🇽',
  '🇸🇾',
  '🇸🇿',
  '🇸',
  '🇹🇦',
  '🇹🇨',
  '🇹🇩',
  '🇹🇫',
  '🇹🇬',
  '🇹🇭',
  '🇹🇯',
  '🇹🇰',
  '🇹🇱',
  '🇹🇲',
  '🇹🇳',
  '🇹🇴',
  '🇹🇷',
  '🇹🇹',
  '🇹🇻',
  '🇹🇼',
  '🇹🇿',
  '🇹',
  '🇺🇦',
  '🇺🇬',
  '🇺🇲',
  '🇺🇳',
  '🇺🇸',
  '🇺🇾',
  '🇺🇿',
  '🇺',
  '🇻🇦',
  '🇻🇨',
  '🇻🇪',
  '🇻🇬',
  '🇻🇮',
  '🇻🇳',
  '🇻🇺',
  '🇻',
  '🇼🇫',
  '🇼🇸',
  '🇼',
  '🇽🇰',
  '🇽',
  '🇾🇪',
  '🇾🇹',
  '🇾',
  '🇿🇦',
  '🇿🇲',
  '🇿🇼',
  '🇿',
  '🈁',
  '🈂',
  '🈚',
  '🈯',
  '🈲',
  '🈳',
  '🈴',
  '🈵',
  '🈶',
  '🈷',
  '🈸',
  '🈹',
  '🈺',
  '🉐',
  '🉑',
  '🌀',
  '🌁',
  '🌂',
  '🌃',
  '🌄',
  '🌅',
  '🌆',
  '🌇',
  '🌈',
  '🌉',
  '🌊',
  '🌋',
  '🌌',
  '🌍',
  '🌎',
  '🌏',
  '🌐',
  '🌑',
  '🌒',
  '🌓',
  '🌔',
  '🌕',
  '🌖',
  '🌗',
  '🌘',
  '🌙',
  '🌚',
  '🌛',
  '🌜',
  '🌝',
  '🌞',
  '🌟',
  '🌠',
  '🌡',
  '🌤',
  '🌥',
  '🌦',
  '🌧',
  '🌨',
  '🌩',
  '🌪',
  '🌫',
  '🌬',
  '🌭',
  '🌮',
  '🌯',
  '🌰',
  '🌱',
  '🌲',
  '🌳',
  '🌴',
  '🌵',
  '🌶',
  '🌷',
  '🌸',
  '🌹',
  '🌺',
  '🌻',
  '🌼',
  '🌽',
  '🌾',
  '🌿',
  '🍀',
  '🍁',
  '🍂',
  '🍃',
  '🍄',
  '🍅',
  '🍆',
  '🍇',
  '🍈',
  '🍉',
  '🍊',
  '🍋',
  '🍌',
  '🍍',
  '🍎',
  '🍏',
  '🍐',
  '🍑',
  '🍒',
  '🍓',
  '🍔',
  '🍕',
  '🍖',
  '🍗',
  '🍘',
  '🍙',
  '🍚',
  '🍛',
  '🍜',
  '🍝',
  '🍞',
  '🍟',
  '🍠',
  '🍡',
  '🍢',
  '🍣',
  '🍤',
  '🍥',
  '🍦',
  '🍧',
  '🍨',
  '🍩',
  '🍪',
  '🍫',
  '🍬',
  '🍭',
  '🍮',
  '🍯',
  '🍰',
  '🍱',
  '🍲',
  '🍳',
  '🍴',
  '🍵',
  '🍶',
  '🍷',
  '🍸',
  '🍹',
  '🍺',
  '🍻',
  '🍼',
  '🍽',
  '🍾',
  '🍿',
  '🎀',
  '🎁',
  '🎂',
  '🎃',
  '🎄',
  '🎅🏻',
  '🎅🏼',
  '🎅🏽',
  '🎅🏾',
  '🎅🏿',
  '🎅',
  '🎆',
  '🎇',
  '🎈',
  '🎉',
  '🎊',
  '🎋',
  '🎌',
  '🎍',
  '🎎',
  '🎏',
  '🎐',
  '🎑',
  '🎒',
  '🎓',
  '🎖',
  '🎗',
  '🎙',
  '🎚',
  '🎛',
  '🎞',
  '🎟',
  '🎠',
  '🎡',
  '🎢',
  '🎣',
  '🎤',
  '🎥',
  '🎦',
  '🎧',
  '🎨',
  '🎩',
  '🎪',
  '🎫',
  '🎬',
  '🎭',
  '🎮',
  '🎯',
  '🎰',
  '🎱',
  '🎲',
  '🎳',
  '🎴',
  '🎵',
  '🎶',
  '🎷',
  '🎸',
  '🎹',
  '🎺',
  '🎻',
  '🎼',
  '🎽',
  '🎾',
  '🎿',
  '🏀',
  '🏁',
  '🏂🏻',
  '🏂🏼',
  '🏂🏽',
  '🏂🏾',
  '🏂🏿',
  '🏂',
  '🏃🏻‍♀️',
  '🏃🏻‍♂️',
  '🏃🏻',
  '🏃🏼‍♀️',
  '🏃🏼‍♂️',
  '🏃🏼',
  '🏃🏽‍♀️',
  '🏃🏽‍♂️',
  '🏃🏽',
  '🏃🏾‍♀️',
  '🏃🏾‍♂️',
  '🏃🏾',
  '🏃🏿‍♀️',
  '🏃🏿‍♂️',
  '🏃🏿',
  '🏃‍♀️',
  '🏃‍♂️',
  '🏃',
  '🏄🏻‍♀️',
  '🏄🏻‍♂️',
  '🏄🏻',
  '🏄🏼‍♀️',
  '🏄🏼‍♂️',
  '🏄🏼',
  '🏄🏽‍♀️',
  '🏄🏽‍♂️',
  '🏄🏽',
  '🏄🏾‍♀️',
  '🏄🏾‍♂️',
  '🏄🏾',
  '🏄🏿‍♀️',
  '🏄🏿‍♂️',
  '🏄🏿',
  '🏄‍♀️',
  '🏄‍♂️',
  '🏄',
  '🏅',
  '🏆',
  '🏇🏻',
  '🏇🏼',
  '🏇🏽',
  '🏇🏾',
  '🏇🏿',
  '🏇',
  '🏈',
  '🏉',
  '🏊🏻‍♀️',
  '🏊🏻‍♂️',
  '🏊🏻',
  '🏊🏼‍♀️',
  '🏊🏼‍♂️',
  '🏊🏼',
  '🏊🏽‍♀️',
  '🏊🏽‍♂️',
  '🏊🏽',
  '🏊🏾‍♀️',
  '🏊🏾‍♂️',
  '🏊🏾',
  '🏊🏿‍♀️',
  '🏊🏿‍♂️',
  '🏊🏿',
  '🏊‍♀️',
  '🏊‍♂️',
  '🏊',
  '🏋🏻‍♀️',
  '🏋🏻‍♂️',
  '🏋🏻',
  '🏋🏼‍♀️',
  '🏋🏼‍♂️',
  '🏋🏼',
  '🏋🏽‍♀️',
  '🏋🏽‍♂️',
  '🏋🏽',
  '🏋🏾‍♀️',
  '🏋🏾‍♂️',
  '🏋🏾',
  '🏋🏿‍♀️',
  '🏋🏿‍♂️',
  '🏋🏿',
  '🏋️‍♀️',
  '🏋️‍♂️',
  '🏋',
  '🏌🏻‍♀️',
  '🏌🏻‍♂️',
  '🏌🏻',
  '🏌🏼‍♀️',
  '🏌🏼‍♂️',
  '🏌🏼',
  '🏌🏽‍♀️',
  '🏌🏽‍♂️',
  '🏌🏽',
  '🏌🏾‍♀️',
  '🏌🏾‍♂️',
  '🏌🏾',
  '🏌🏿‍♀️',
  '🏌🏿‍♂️',
  '🏌🏿',
  '🏌️‍♀️',
  '🏌️‍♂️',
  '🏌',
  '🏍',
  '🏎',
  '🏏',
  '🏐',
  '🏑',
  '🏒',
  '🏓',
  '🏔',
  '🏕',
  '🏖',
  '🏗',
  '🏘',
  '🏙',
  '🏚',
  '🏛',
  '🏜',
  '🏝',
  '🏞',
  '🏟',
  '🏠',
  '🏡',
  '🏢',
  '🏣',
  '🏤',
  '🏥',
  '🏦',
  '🏧',
  '🏨',
  '🏩',
  '🏪',
  '🏫',
  '🏬',
  '🏭',
  '🏮',
  '🏯',
  '🏰',
  '🏳️‍🌈',
  '🏳',
  '🏴‍☠️',
  '🏴',
  '🏵',
  '🏷',
  '🏸',
  '🏹',
  '🏺',
  '🏻',
  '🏼',
  '🏽',
  '🏾',
  '🏿',
  '🐀',
  '🐁',
  '🐂',
  '🐃',
  '🐄',
  '🐅',
  '🐆',
  '🐇',
  '🐈',
  '🐉',
  '🐊',
  '🐋',
  '🐌',
  '🐍',
  '🐎',
  '🐏',
  '🐐',
  '🐑',
  '🐒',
  '🐓',
  '🐔',
  '🐕',
  '🐖',
  '🐗',
  '🐘',
  '🐙',
  '🐚',
  '🐛',
  '🐜',
  '🐝',
  '🐞',
  '🐟',
  '🐠',
  '🐡',
  '🐢',
  '🐣',
  '🐤',
  '🐥',
  '🐦',
  '🐧',
  '🐨',
  '🐩',
  '🐪',
  '🐫',
  '🐬',
  '🐭',
  '🐮',
  '🐯',
  '🐰',
  '🐱',
  '🐲',
  '🐳',
  '🐴',
  '🐵',
  '🐶',
  '🐷',
  '🐸',
  '🐹',
  '🐺',
  '🐻',
  '🐼',
  '🐽',
  '🐾',
  '🐿',
  '👀',
  '👁‍🗨',
  '👁',
  '👂🏻',
  '👂🏼',
  '👂🏽',
  '👂🏾',
  '👂🏿',
  '👂',
  '👃🏻',
  '👃🏼',
  '👃🏽',
  '👃🏾',
  '👃🏿',
  '👃',
  '👄',
  '👅',
  '👆🏻',
  '👆🏼',
  '👆🏽',
  '👆🏾',
  '👆🏿',
  '👆',
  '👇🏻',
  '👇🏼',
  '👇🏽',
  '👇🏾',
  '👇🏿',
  '👇',
  '👈🏻',
  '👈🏼',
  '👈🏽',
  '👈🏾',
  '👈🏿',
  '👈',
  '👉🏻',
  '👉🏼',
  '👉🏽',
  '👉🏾',
  '👉🏿',
  '👉',
  '👊🏻',
  '👊🏼',
  '👊🏽',
  '👊🏾',
  '👊🏿',
  '👊',
  '👋🏻',
  '👋🏼',
  '👋🏽',
  '👋🏾',
  '👋🏿',
  '👋',
  '👌🏻',
  '👌🏼',
  '👌🏽',
  '👌🏾',
  '👌🏿',
  '👌',
  '👍🏻',
  '👍🏼',
  '👍🏽',
  '👍🏾',
  '👍🏿',
  '👍',
  '👎🏻',
  '👎🏼',
  '👎🏽',
  '👎🏾',
  '👎🏿',
  '👎',
  '👏🏻',
  '👏🏼',
  '👏🏽',
  '👏🏾',
  '👏🏿',
  '👏',
  '👐🏻',
  '👐🏼',
  '👐🏽',
  '👐🏾',
  '👐🏿',
  '👐',
  '👑',
  '👒',
  '👓',
  '👔',
  '👕',
  '👖',
  '👗',
  '👘',
  '👙',
  '👚',
  '👛',
  '👜',
  '👝',
  '👞',
  '👟',
  '👠',
  '👡',
  '👢',
  '👣',
  '👤',
  '👥',
  '👦🏻',
  '👦🏼',
  '👦🏽',
  '👦🏾',
  '👦🏿',
  '👦',
  '👧🏻',
  '👧🏼',
  '👧🏽',
  '👧🏾',
  '👧🏿',
  '👧',
  '👨🏻‍🌾',
  '👨🏻‍🍳',
  '👨🏻‍🎓',
  '👨🏻‍🎤',
  '👨🏻‍🎨',
  '👨🏻‍🏫',
  '👨🏻‍🏭',
  '👨🏻‍💻',
  '👨🏻‍💼',
  '👨🏻‍🔧',
  '👨🏻‍🔬',
  '👨🏻‍🚀',
  '👨🏻‍🚒',
  '👨🏻‍⚕️',
  '👨🏻‍⚖️',
  '👨🏻‍✈️',
  '👨🏻',
  '👨🏼‍🌾',
  '👨🏼‍🍳',
  '👨🏼‍🎓',
  '👨🏼‍🎤',
  '👨🏼‍🎨',
  '👨🏼‍🏫',
  '👨🏼‍🏭',
  '👨🏼‍💻',
  '👨🏼‍💼',
  '👨🏼‍🔧',
  '👨🏼‍🔬',
  '👨🏼‍🚀',
  '👨🏼‍🚒',
  '👨🏼‍⚕️',
  '👨🏼‍⚖️',
  '👨🏼‍✈️',
  '👨🏼',
  '👨🏽‍🌾',
  '👨🏽‍🍳',
  '👨🏽‍🎓',
  '👨🏽‍🎤',
  '👨🏽‍🎨',
  '👨🏽‍🏫',
  '👨🏽‍🏭',
  '👨🏽‍💻',
  '👨🏽‍💼',
  '👨🏽‍🔧',
  '👨🏽‍🔬',
  '👨🏽‍🚀',
  '👨🏽‍🚒',
  '👨🏽‍⚕️',
  '👨🏽‍⚖️',
  '👨🏽‍✈️',
  '👨🏽',
  '👨🏾‍🌾',
  '👨🏾‍🍳',
  '👨🏾‍🎓',
  '👨🏾‍🎤',
  '👨🏾‍🎨',
  '👨🏾‍🏫',
  '👨🏾‍🏭',
  '👨🏾‍💻',
  '👨🏾‍💼',
  '👨🏾‍🔧',
  '👨🏾‍🔬',
  '👨🏾‍🚀',
  '👨🏾‍🚒',
  '👨🏾‍⚕️',
  '👨🏾‍⚖️',
  '👨🏾‍✈️',
  '👨🏾',
  '👨🏿‍🌾',
  '👨🏿‍🍳',
  '👨🏿‍🎓',
  '👨🏿‍🎤',
  '👨🏿‍🎨',
  '👨🏿‍🏫',
  '👨🏿‍🏭',
  '👨🏿‍💻',
  '👨🏿‍💼',
  '👨🏿‍🔧',
  '👨🏿‍🔬',
  '👨🏿‍🚀',
  '👨🏿‍🚒',
  '👨🏿‍⚕️',
  '👨🏿‍⚖️',
  '👨🏿‍✈️',
  '👨🏿',
  '👨‍🌾',
  '👨‍🍳',
  '👨‍🎓',
  '👨‍🎤',
  '👨‍🎨',
  '👨‍🏫',
  '👨‍🏭',
  '👨‍👦‍👦',
  '👨‍👦',
  '👨‍👧‍👦',
  '👨‍👧‍👧',
  '👨‍👧',
  '👨‍👨‍👦‍👦',
  '👨‍👨‍👦',
  '👨‍👨‍👧‍👦',
  '👨‍👨‍👧‍👧',
  '👨‍👨‍👧',
  '👨‍👩‍👦‍👦',
  '👨‍👩‍👦',
  '👨‍👩‍👧‍👦',
  '👨‍👩‍👧‍👧',
  '👨‍👩‍👧',
  '👨‍💻',
  '👨‍💼',
  '👨‍🔧',
  '👨‍🔬',
  '👨‍🚀',
  '👨‍🚒',
  '👨‍⚕️',
  '👨‍⚖️',
  '👨‍✈️',
  '👨‍❤️‍👨',
  '👨‍❤️‍💋‍👨',
  '👨',
  '👩🏻‍🌾',
  '👩🏻‍🍳',
  '👩🏻‍🎓',
  '👩🏻‍🎤',
  '👩🏻‍🎨',
  '👩🏻‍🏫',
  '👩🏻‍🏭',
  '👩🏻‍💻',
  '👩🏻‍💼',
  '👩🏻‍🔧',
  '👩🏻‍🔬',
  '👩🏻‍🚀',
  '👩🏻‍🚒',
  '👩🏻‍⚕️',
  '👩🏻‍⚖️',
  '👩🏻‍✈️',
  '👩🏻',
  '👩🏼‍🌾',
  '👩🏼‍🍳',
  '👩🏼‍🎓',
  '👩🏼‍🎤',
  '👩🏼‍🎨',
  '👩🏼‍🏫',
  '👩🏼‍🏭',
  '👩🏼‍💻',
  '👩🏼‍💼',
  '👩🏼‍🔧',
  '👩🏼‍🔬',
  '👩🏼‍🚀',
  '👩🏼‍🚒',
  '👩🏼‍⚕️',
  '👩🏼‍⚖️',
  '👩🏼‍✈️',
  '👩🏼',
  '👩🏽‍🌾',
  '👩🏽‍🍳',
  '👩🏽‍🎓',
  '👩🏽‍🎤',
  '👩🏽‍🎨',
  '👩🏽‍🏫',
  '👩🏽‍🏭',
  '👩🏽‍💻',
  '👩🏽‍💼',
  '👩🏽‍🔧',
  '👩🏽‍🔬',
  '👩🏽‍🚀',
  '👩🏽‍🚒',
  '👩🏽‍⚕️',
  '👩🏽‍⚖️',
  '👩🏽‍✈️',
  '👩🏽',
  '👩🏾‍🌾',
  '👩🏾‍🍳',
  '👩🏾‍🎓',
  '👩🏾‍🎤',
  '👩🏾‍🎨',
  '👩🏾‍🏫',
  '👩🏾‍🏭',
  '👩🏾‍💻',
  '👩🏾‍💼',
  '👩🏾‍🔧',
  '👩🏾‍🔬',
  '👩🏾‍🚀',
  '👩🏾‍🚒',
  '👩🏾‍⚕️',
  '👩🏾‍⚖️',
  '👩🏾‍✈️',
  '👩🏾',
  '👩🏿‍🌾',
  '👩🏿‍🍳',
  '👩🏿‍🎓',
  '👩🏿‍🎤',
  '👩🏿‍🎨',
  '👩🏿‍🏫',
  '👩🏿‍🏭',
  '👩🏿‍💻',
  '👩🏿‍💼',
  '👩🏿‍🔧',
  '👩🏿‍🔬',
  '👩🏿‍🚀',
  '👩🏿‍🚒',
  '👩🏿‍⚕️',
  '👩🏿‍⚖️',
  '👩🏿‍✈️',
  '👩🏿',
  '👩‍🌾',
  '👩‍🍳',
  '👩‍🎓',
  '👩‍🎤',
  '👩‍🎨',
  '👩‍🏫',
  '👩‍🏭',
  '👩‍👦‍👦',
  '👩‍👦',
  '👩‍👧‍👦',
  '👩‍👧‍👧',
  '👩‍👧',
  '👩‍👩‍👦‍👦',
  '👩‍👩‍👦',
  '👩‍👩‍👧‍👦',
  '👩‍👩‍👧‍👧',
  '👩‍👩‍👧',
  '👩‍💻',
  '👩‍💼',
  '👩‍🔧',
  '👩‍🔬',
  '👩‍🚀',
  '👩‍🚒',
  '👩‍⚕️',
  '👩‍⚖️',
  '👩‍✈️',
  '👩‍❤️‍👨',
  '👩‍❤️‍👩',
  '👩‍❤️‍💋‍👨',
  '👩‍❤️‍💋‍👩',
  '👩',
  '👪🏻',
  '👪🏼',
  '👪🏽',
  '👪🏾',
  '👪🏿',
  '👪',
  '👫🏻',
  '👫🏼',
  '👫🏽',
  '👫🏾',
  '👫🏿',
  '👫',
  '👬🏻',
  '👬🏼',
  '👬🏽',
  '👬🏾',
  '👬🏿',
  '👬',
  '👭🏻',
  '👭🏼',
  '👭🏽',
  '👭🏾',
  '👭🏿',
  '👭',
  '👮🏻‍♀️',
  '👮🏻‍♂️',
  '👮🏻',
  '👮🏼‍♀️',
  '👮🏼‍♂️',
  '👮🏼',
  '👮🏽‍♀️',
  '👮🏽‍♂️',
  '👮🏽',
  '👮🏾‍♀️',
  '👮🏾‍♂️',
  '👮🏾',
  '👮🏿‍♀️',
  '👮🏿‍♂️',
  '👮🏿',
  '👮‍♀️',
  '👮‍♂️',
  '👮',
  '👯🏻‍♀️',
  '👯🏻‍♂️',
  '👯🏻',
  '👯🏼‍♀️',
  '👯🏼‍♂️',
  '👯🏼',
  '👯🏽‍♀️',
  '👯🏽‍♂️',
  '👯🏽',
  '👯🏾‍♀️',
  '👯🏾‍♂️',
  '👯🏾',
  '👯🏿‍♀️',
  '👯🏿‍♂️',
  '👯🏿',
  '👯‍♀️',
  '👯‍♂️',
  '👯',
  '👰🏻',
  '👰🏼',
  '👰🏽',
  '👰🏾',
  '👰🏿',
  '👰',
  '👱🏻‍♀️',
  '👱🏻‍♂️',
  '👱🏻',
  '👱🏼‍♀️',
  '👱🏼‍♂️',
  '👱🏼',
  '👱🏽‍♀️',
  '👱🏽‍♂️',
  '👱🏽',
  '👱🏾‍♀️',
  '👱🏾‍♂️',
  '👱🏾',
  '👱🏿‍♀️',
  '👱🏿‍♂️',
  '👱🏿',
  '👱‍♀️',
  '👱‍♂️',
  '👱',
  '👲🏻',
  '👲🏼',
  '👲🏽',
  '👲🏾',
  '👲🏿',
  '👲',
  '👳🏻‍♀️',
  '👳🏻‍♂️',
  '👳🏻',
  '👳🏼‍♀️',
  '👳🏼‍♂️',
  '👳🏼',
  '👳🏽‍♀️',
  '👳🏽‍♂️',
  '👳🏽',
  '👳🏾‍♀️',
  '👳🏾‍♂️',
  '👳🏾',
  '👳🏿‍♀️',
  '👳🏿‍♂️',
  '👳🏿',
  '👳‍♀️',
  '👳‍♂️',
  '👳',
  '👴🏻',
  '👴🏼',
  '👴🏽',
  '👴🏾',
  '👴🏿',
  '👴',
  '👵🏻',
  '👵🏼',
  '👵🏽',
  '👵🏾',
  '👵🏿',
  '👵',
  '👶🏻',
  '👶🏼',
  '👶🏽',
  '👶🏾',
  '👶🏿',
  '👶',
  '👷🏻‍♀️',
  '👷🏻‍♂️',
  '👷🏻',
  '👷🏼‍♀️',
  '👷🏼‍♂️',
  '👷🏼',
  '👷🏽‍♀️',
  '👷🏽‍♂️',
  '👷🏽',
  '👷🏾‍♀️',
  '👷🏾‍♂️',
  '👷🏾',
  '👷🏿‍♀️',
  '👷🏿‍♂️',
  '👷🏿',
  '👷‍♀️',
  '👷‍♂️',
  '👷',
  '👸🏻',
  '👸🏼',
  '👸🏽',
  '👸🏾',
  '👸🏿',
  '👸',
  '👹',
  '👺',
  '👻',
  '👼🏻',
  '👼🏼',
  '👼🏽',
  '👼🏾',
  '👼🏿',
  '👼',
  '👽',
  '👾',
  '👿',
  '💀',
  '💁🏻‍♀️',
  '💁🏻‍♂️',
  '💁🏻',
  '💁🏼‍♀️',
  '💁🏼‍♂️',
  '💁🏼',
  '💁🏽‍♀️',
  '💁🏽‍♂️',
  '💁🏽',
  '💁🏾‍♀️',
  '💁🏾‍♂️',
  '💁🏾',
  '💁🏿‍♀️',
  '💁🏿‍♂️',
  '💁🏿',
  '💁‍♀️',
  '💁‍♂️',
  '💁',
  '💂🏻‍♀️',
  '💂🏻‍♂️',
  '💂🏻',
  '💂🏼‍♀️',
  '💂🏼‍♂️',
  '💂🏼',
  '💂🏽‍♀️',
  '💂🏽‍♂️',
  '💂🏽',
  '💂🏾‍♀️',
  '💂🏾‍♂️',
  '💂🏾',
  '💂🏿‍♀️',
  '💂🏿‍♂️',
  '💂🏿',
  '💂‍♀️',
  '💂‍♂️',
  '💂',
  '💃🏻',
  '💃🏼',
  '💃🏽',
  '💃🏾',
  '💃🏿',
  '💃',
  '💄',
  '💅🏻',
  '💅🏼',
  '💅🏽',
  '💅🏾',
  '💅🏿',
  '💅',
  '💆🏻‍♀️',
  '💆🏻‍♂️',
  '💆🏻',
  '💆🏼‍♀️',
  '💆🏼‍♂️',
  '💆🏼',
  '💆🏽‍♀️',
  '💆🏽‍♂️',
  '💆🏽',
  '💆🏾‍♀️',
  '💆🏾‍♂️',
  '💆🏾',
  '💆🏿‍♀️',
  '💆🏿‍♂️',
  '💆🏿',
  '💆‍♀️',
  '💆‍♂️',
  '💆',
  '💇🏻‍♀️',
  '💇🏻‍♂️',
  '💇🏻',
  '💇🏼‍♀️',
  '💇🏼‍♂️',
  '💇🏼',
  '💇🏽‍♀️',
  '💇🏽‍♂️',
  '💇🏽',
  '💇🏾‍♀️',
  '💇🏾‍♂️',
  '💇🏾',
  '💇🏿‍♀️',
  '💇🏿‍♂️',
  '💇🏿',
  '💇‍♀️',
  '💇‍♂️',
  '💇',
  '💈',
  '💉',
  '💊',
  '💋',
  '💌',
  '💍',
  '💎',
  '💏',
  '💐',
  '💑',
  '💒',
  '💓',
  '💔',
  '💕',
  '💖',
  '💗',
  '💘',
  '💙',
  '💚',
  '💛',
  '💜',
  '💝',
  '💞',
  '💟',
  '💠',
  '💡',
  '💢',
  '💣',
  '💤',
  '💥',
  '💦',
  '💧',
  '💨',
  '💩',
  '💪🏻',
  '💪🏼',
  '💪🏽',
  '💪🏾',
  '💪🏿',
  '💪',
  '💫',
  '💬',
  '💭',
  '💮',
  '💯',
  '💰',
  '💱',
  '💲',
  '💳',
  '💴',
  '💵',
  '💶',
  '💷',
  '💸',
  '💹',
  '💺',
  '💻',
  '💼',
  '💽',
  '💾',
  '💿',
  '📀',
  '📁',
  '📂',
  '📃',
  '📄',
  '📅',
  '📆',
  '📇',
  '📈',
  '📉',
  '📊',
  '📋',
  '📌',
  '📍',
  '📎',
  '📏',
  '📐',
  '📑',
  '📒',
  '📓',
  '📔',
  '📕',
  '📖',
  '📗',
  '📘',
  '📙',
  '📚',
  '📛',
  '📜',
  '📝',
  '📞',
  '📟',
  '📠',
  '📡',
  '📢',
  '📣',
  '📤',
  '📥',
  '📦',
  '📧',
  '📨',
  '📩',
  '📪',
  '📫',
  '📬',
  '📭',
  '📮',
  '📯',
  '📰',
  '📱',
  '📲',
  '📳',
  '📴',
  '📵',
  '📶',
  '📷',
  '📸',
  '📹',
  '📺',
  '📻',
  '📼',
  '📽',
  '📿',
  '🔀',
  '🔁',
  '🔂',
  '🔃',
  '🔄',
  '🔅',
  '🔆',
  '🔇',
  '🔈',
  '🔉',
  '🔊',
  '🔋',
  '🔌',
  '🔍',
  '🔎',
  '🔏',
  '🔐',
  '🔑',
  '🔒',
  '🔓',
  '🔔',
  '🔕',
  '🔖',
  '🔗',
  '🔘',
  '🔙',
  '🔚',
  '🔛',
  '🔜',
  '🔝',
  '🔞',
  '🔟',
  '🔠',
  '🔡',
  '🔢',
  '🔣',
  '🔤',
  '🔥',
  '🔦',
  '🔧',
  '🔨',
  '🔩',
  '🔪',
  '🔫',
  '🔬',
  '🔭',
  '🔮',
  '🔯',
  '🔰',
  '🔱',
  '🔲',
  '🔳',
  '🔴',
  '🔵',
  '🔶',
  '🔷',
  '🔸',
  '🔹',
  '🔺',
  '🔻',
  '🔼',
  '🔽',
  '🕉',
  '🕊',
  '🕋',
  '🕌',
  '🕍',
  '🕎',
  '🕐',
  '🕑',
  '🕒',
  '🕓',
  '🕔',
  '🕕',
  '🕖',
  '🕗',
  '🕘',
  '🕙',
  '🕚',
  '🕛',
  '🕜',
  '🕝',
  '🕞',
  '🕟',
  '🕠',
  '🕡',
  '🕢',
  '🕣',
  '🕤',
  '🕥',
  '🕦',
  '🕧',
  '🕯',
  '🕰',
  '🕳',
  '🕴🏻',
  '🕴🏼',
  '🕴🏽',
  '🕴🏾',
  '🕴🏿',
  '🕴',
  '🕵🏻‍♀️',
  '🕵🏻‍♂️',
  '🕵🏻',
  '🕵🏼‍♀️',
  '🕵🏼‍♂️',
  '🕵🏼',
  '🕵🏽‍♀️',
  '🕵🏽‍♂️',
  '🕵🏽',
  '🕵🏾‍♀️',
  '🕵🏾‍♂️',
  '🕵🏾',
  '🕵🏿‍♀️',
  '🕵🏿‍♂️',
  '🕵🏿',
  '🕵️‍♀️',
  '🕵️‍♂️',
  '🕵',
  '🕶',
  '🕷',
  '🕸',
  '🕹',
  '🕺🏻',
  '🕺🏼',
  '🕺🏽',
  '🕺🏾',
  '🕺🏿',
  '🕺',
  '🖇',
  '🖊',
  '🖋',
  '🖌',
  '🖍',
  '🖐🏻',
  '🖐🏼',
  '🖐🏽',
  '🖐🏾',
  '🖐🏿',
  '🖐',
  '🖕🏻',
  '🖕🏼',
  '🖕🏽',
  '🖕🏾',
  '🖕🏿',
  '🖕',
  '🖖🏻',
  '🖖🏼',
  '🖖🏽',
  '🖖🏾',
  '🖖🏿',
  '🖖',
  '🖤',
  '🖥',
  '🖨',
  '🖱',
  '🖲',
  '🖼',
  '🗂',
  '🗃',
  '🗄',
  '🗑',
  '🗒',
  '🗓',
  '🗜',
  '🗝',
  '🗞',
  '🗡',
  '🗣',
  '🗨',
  '🗯',
  '🗳',
  '🗺',
  '🗻',
  '🗼',
  '🗽',
  '🗾',
  '🗿',
  '😀',
  '😁',
  '😂',
  '😃',
  '😄',
  '😅',
  '😆',
  '😇',
  '😈',
  '😉',
  '😊',
  '😋',
  '😌',
  '😍',
  '😎',
  '😏',
  '😐',
  '😑',
  '😒',
  '😓',
  '😔',
  '😕',
  '😖',
  '😗',
  '😘',
  '😙',
  '😚',
  '😛',
  '😜',
  '😝',
  '😞',
  '😟',
  '😠',
  '😡',
  '😢',
  '😣',
  '😤',
  '😥',
  '😦',
  '😧',
  '😨',
  '😩',
  '😪',
  '😫',
  '😬',
  '😭',
  '😮',
  '😯',
  '😰',
  '😱',
  '😲',
  '😳',
  '😴',
  '😵',
  '😶',
  '😷',
  '😸',
  '😹',
  '😺',
  '😻',
  '😼',
  '😽',
  '😾',
  '😿',
  '🙀',
  '🙁',
  '🙂',
  '🙃',
  '🙄',
  '🙅🏻‍♀️',
  '🙅🏻‍♂️',
  '🙅🏻',
  '🙅🏼‍♀️',
  '🙅🏼‍♂️',
  '🙅🏼',
  '🙅🏽‍♀️',
  '🙅🏽‍♂️',
  '🙅🏽',
  '🙅🏾‍♀️',
  '🙅🏾‍♂️',
  '🙅🏾',
  '🙅🏿‍♀️',
  '🙅🏿‍♂️',
  '🙅🏿',
  '🙅‍♀️',
  '🙅‍♂️',
  '🙅',
  '🙆🏻‍♀️',
  '🙆🏻‍♂️',
  '🙆🏻',
  '🙆🏼‍♀️',
  '🙆🏼‍♂️',
  '🙆🏼',
  '🙆🏽‍♀️',
  '🙆🏽‍♂️',
  '🙆🏽',
  '🙆🏾‍♀️',
  '🙆🏾‍♂️',
  '🙆🏾',
  '🙆🏿‍♀️',
  '🙆🏿‍♂️',
  '🙆🏿',
  '🙆‍♀️',
  '🙆‍♂️',
  '🙆',
  '🙇🏻‍♀️',
  '🙇🏻‍♂️',
  '🙇🏻',
  '🙇🏼‍♀️',
  '🙇🏼‍♂️',
  '🙇🏼',
  '🙇🏽‍♀️',
  '🙇🏽‍♂️',
  '🙇🏽',
  '🙇🏾‍♀️',
  '🙇🏾‍♂️',
  '🙇🏾',
  '🙇🏿‍♀️',
  '🙇🏿‍♂️',
  '🙇🏿',
  '🙇‍♀️',
  '🙇‍♂️',
  '🙇',
  '🙈',
  '🙉',
  '🙊',
  '🙋🏻‍♀️',
  '🙋🏻‍♂️',
  '🙋🏻',
  '🙋🏼‍♀️',
  '🙋🏼‍♂️',
  '🙋🏼',
  '🙋🏽‍♀️',
  '🙋🏽‍♂️',
  '🙋🏽',
  '🙋🏾‍♀️',
  '🙋🏾‍♂️',
  '🙋🏾',
  '🙋🏿‍♀️',
  '🙋🏿‍♂️',
  '🙋🏿',
  '🙋‍♀️',
  '🙋‍♂️',
  '🙋',
  '🙌🏻',
  '🙌🏼',
  '🙌🏽',
  '🙌🏾',
  '🙌🏿',
  '🙌',
  '🙍🏻‍♀️',
  '🙍🏻‍♂️',
  '🙍🏻',
  '🙍🏼‍♀️',
  '🙍🏼‍♂️',
  '🙍🏼',
  '🙍🏽‍♀️',
  '🙍🏽‍♂️',
  '🙍🏽',
  '🙍🏾‍♀️',
  '🙍🏾‍♂️',
  '🙍🏾',
  '🙍🏿‍♀️',
  '🙍🏿‍♂️',
  '🙍🏿',
  '🙍‍♀️',
  '🙍‍♂️',
  '🙍',
  '🙎🏻‍♀️',
  '🙎🏻‍♂️',
  '🙎🏻',
  '🙎🏼‍♀️',
  '🙎🏼‍♂️',
  '🙎🏼',
  '🙎🏽‍♀️',
  '🙎🏽‍♂️',
  '🙎🏽',
  '🙎🏾‍♀️',
  '🙎🏾‍♂️',
  '🙎🏾',
  '🙎🏿‍♀️',
  '🙎🏿‍♂️',
  '🙎🏿',
  '🙎‍♀️',
  '🙎‍♂️',
  '🙎',
  '🙏🏻',
  '🙏🏼',
  '🙏🏽',
  '🙏🏾',
  '🙏🏿',
  '🙏',
  '🚀',
  '🚁',
  '🚂',
  '🚃',
  '🚄',
  '🚅',
  '🚆',
  '🚇',
  '🚈',
  '🚉',
  '🚊',
  '🚋',
  '🚌',
  '🚍',
  '🚎',
  '🚏',
  '🚐',
  '🚑',
  '🚒',
  '🚓',
  '🚔',
  '🚕',
  '🚖',
  '🚗',
  '🚘',
  '🚙',
  '🚚',
  '🚛',
  '🚜',
  '🚝',
  '🚞',
  '🚟',
  '🚠',
  '🚡',
  '🚢',
  '🚣🏻‍♀️',
  '🚣🏻‍♂️',
  '🚣🏻',
  '🚣🏼‍♀️',
  '🚣🏼‍♂️',
  '🚣🏼',
  '🚣🏽‍♀️',
  '🚣🏽‍♂️',
  '🚣🏽',
  '🚣🏾‍♀️',
  '🚣🏾‍♂️',
  '🚣🏾',
  '🚣🏿‍♀️',
  '🚣🏿‍♂️',
  '🚣🏿',
  '🚣‍♀️',
  '🚣‍♂️',
  '🚣',
  '🚤',
  '🚥',
  '🚦',
  '🚧',
  '🚨',
  '🚩',
  '🚪',
  '🚫',
  '🚬',
  '🚭',
  '🚮',
  '🚯',
  '🚰',
  '🚱',
  '🚲',
  '🚳',
  '🚴🏻‍♀️',
  '🚴🏻‍♂️',
  '🚴🏻',
  '🚴🏼‍♀️',
  '🚴🏼‍♂️',
  '🚴🏼',
  '🚴🏽‍♀️',
  '🚴🏽‍♂️',
  '🚴🏽',
  '🚴🏾‍♀️',
  '🚴🏾‍♂️',
  '🚴🏾',
  '🚴🏿‍♀️',
  '🚴🏿‍♂️',
  '🚴🏿',
  '🚴‍♀️',
  '🚴‍♂️',
  '🚴',
  '🚵🏻‍♀️',
  '🚵🏻‍♂️',
  '🚵🏻',
  '🚵🏼‍♀️',
  '🚵🏼‍♂️',
  '🚵🏼',
  '🚵🏽‍♀️',
  '🚵🏽‍♂️',
  '🚵🏽',
  '🚵🏾‍♀️',
  '🚵🏾‍♂️',
  '🚵🏾',
  '🚵🏿‍♀️',
  '🚵🏿‍♂️',
  '🚵🏿',
  '🚵‍♀️',
  '🚵‍♂️',
  '🚵',
  '🚶🏻‍♀️',
  '🚶🏻‍♂️',
  '🚶🏻',
  '🚶🏼‍♀️',
  '🚶🏼‍♂️',
  '🚶🏼',
  '🚶🏽‍♀️',
  '🚶🏽‍♂️',
  '🚶🏽',
  '🚶🏾‍♀️',
  '🚶🏾‍♂️',
  '🚶🏾',
  '🚶🏿‍♀️',
  '🚶🏿‍♂️',
  '🚶🏿',
  '🚶‍♀️',
  '🚶‍♂️',
  '🚶',
  '🚷',
  '🚸',
  '🚹',
  '🚺',
  '🚻',
  '🚼',
  '🚽',
  '🚾',
  '🚿',
  '🛀🏻',
  '🛀🏼',
  '🛀🏽',
  '🛀🏾',
  '🛀🏿',
  '🛀',
  '🛁',
  '🛂',
  '🛃',
  '🛄',
  '🛅',
  '🛋',
  '🛌🏻',
  '🛌🏼',
  '🛌🏽',
  '🛌🏾',
  '🛌🏿',
  '🛌',
  '🛍',
  '🛎',
  '🛏',
  '🛐',
  '🛑',
  '🛒',
  '🛠',
  '🛡',
  '🛢',
  '🛣',
  '🛤',
  '🛥',
  '🛩',
  '🛫',
  '🛬',
  '🛰',
  '🛳',
  '🛴',
  '🛵',
  '🛶',
  '🤐',
  '🤑',
  '🤒',
  '🤓',
  '🤔',
  '🤕',
  '🤖',
  '🤗',
  '🤘🏻',
  '🤘🏼',
  '🤘🏽',
  '🤘🏾',
  '🤘🏿',
  '🤘',
  '🤙🏻',
  '🤙🏼',
  '🤙🏽',
  '🤙🏾',
  '🤙🏿',
  '🤙',
  '🤚🏻',
  '🤚🏼',
  '🤚🏽',
  '🤚🏾',
  '🤚🏿',
  '🤚',
  '🤛🏻',
  '🤛🏼',
  '🤛🏽',
  '🤛🏾',
  '🤛🏿',
  '🤛',
  '🤜🏻',
  '🤜🏼',
  '🤜🏽',
  '🤜🏾',
  '🤜🏿',
  '🤜',
  '🤝🏻',
  '🤝🏼',
  '🤝🏽',
  '🤝🏾',
  '🤝🏿',
  '🤝',
  '🤞🏻',
  '🤞🏼',
  '🤞🏽',
  '🤞🏾',
  '🤞🏿',
  '🤞',
  '🤠',
  '🤡',
  '🤢',
  '🤣',
  '🤤',
  '🤥',
  '🤦🏻‍♀️',
  '🤦🏻‍♂️',
  '🤦🏻',
  '🤦🏼‍♀️',
  '🤦🏼‍♂️',
  '🤦🏼',
  '🤦🏽‍♀️',
  '🤦🏽‍♂️',
  '🤦🏽',
  '🤦🏾‍♀️',
  '🤦🏾‍♂️',
  '🤦🏾',
  '🤦🏿‍♀️',
  '🤦🏿‍♂️',
  '🤦🏿',
  '🤦‍♀️',
  '🤦‍♂️',
  '🤦',
  '🤧',
  '🤰🏻',
  '🤰🏼',
  '🤰🏽',
  '🤰🏾',
  '🤰🏿',
  '🤰',
  '🤳🏻',
  '🤳🏼',
  '🤳🏽',
  '🤳🏾',
  '🤳🏿',
  '🤳',
  '🤴🏻',
  '🤴🏼',
  '🤴🏽',
  '🤴🏾',
  '🤴🏿',
  '🤴',
  '🤵🏻',
  '🤵🏼',
  '🤵🏽',
  '🤵🏾',
  '🤵🏿',
  '🤵',
  '🤶🏻',
  '🤶🏼',
  '🤶🏽',
  '🤶🏾',
  '🤶🏿',
  '🤶',
  '🤷🏻‍♀️',
  '🤷🏻‍♂️',
  '🤷🏻',
  '🤷🏼‍♀️',
  '🤷🏼‍♂️',
  '🤷🏼',
  '🤷🏽‍♀️',
  '🤷🏽‍♂️',
  '🤷🏽',
  '🤷🏾‍♀️',
  '🤷🏾‍♂️',
  '🤷🏾',
  '🤷🏿‍♀️',
  '🤷🏿‍♂️',
  '🤷🏿',
  '🤷‍♀️',
  '🤷‍♂️',
  '🤷',
  '🤸🏻‍♀️',
  '🤸🏻‍♂️',
  '🤸🏻',
  '🤸🏼‍♀️',
  '🤸🏼‍♂️',
  '🤸🏼',
  '🤸🏽‍♀️',
  '🤸🏽‍♂️',
  '🤸🏽',
  '🤸🏾‍♀️',
  '🤸🏾‍♂️',
  '🤸🏾',
  '🤸🏿‍♀️',
  '🤸🏿‍♂️',
  '🤸🏿',
  '🤸‍♀️',
  '🤸‍♂️',
  '🤸',
  '🤹🏻‍♀️',
  '🤹🏻‍♂️',
  '🤹🏻',
  '🤹🏼‍♀️',
  '🤹🏼‍♂️',
  '🤹🏼',
  '🤹🏽‍♀️',
  '🤹🏽‍♂️',
  '🤹🏽',
  '🤹🏾‍♀️',
  '🤹🏾‍♂️',
  '🤹🏾',
  '🤹🏿‍♀️',
  '🤹🏿‍♂️',
  '🤹🏿',
  '🤹‍♀️',
  '🤹‍♂️',
  '🤹',
  '🤺',
  '🤼🏻‍♀️',
  '🤼🏻‍♂️',
  '🤼🏻',
  '🤼🏼‍♀️',
  '🤼🏼‍♂️',
  '🤼🏼',
  '🤼🏽‍♀️',
  '🤼🏽‍♂️',
  '🤼🏽',
  '🤼🏾‍♀️',
  '🤼🏾‍♂️',
  '🤼🏾',
  '🤼🏿‍♀️',
  '🤼🏿‍♂️',
  '🤼🏿',
  '🤼‍♀️',
  '🤼‍♂️',
  '🤼',
  '🤽🏻‍♀️',
  '🤽🏻‍♂️',
  '🤽🏻',
  '🤽🏼‍♀️',
  '🤽🏼‍♂️',
  '🤽🏼',
  '🤽🏽‍♀️',
  '🤽🏽‍♂️',
  '🤽🏽',
  '🤽🏾‍♀️',
  '🤽🏾‍♂️',
  '🤽🏾',
  '🤽🏿‍♀️',
  '🤽🏿‍♂️',
  '🤽🏿',
  '🤽‍♀️',
  '🤽‍♂️',
  '🤽',
  '🤾🏻‍♀️',
  '🤾🏻‍♂️',
  '🤾🏻',
  '🤾🏼‍♀️',
  '🤾🏼‍♂️',
  '🤾🏼',
  '🤾🏽‍♀️',
  '🤾🏽‍♂️',
  '🤾🏽',
  '🤾🏾‍♀️',
  '🤾🏾‍♂️',
  '🤾🏾',
  '🤾🏿‍♀️',
  '🤾🏿‍♂️',
  '🤾🏿',
  '🤾‍♀️',
  '🤾‍♂️',
  '🤾',
  '🥀',
  '🥁',
  '🥂',
  '🥃',
  '🥄',
  '🥅',
  '🥇',
  '🥈',
  '🥉',
  '🥊',
  '🥋',
  '🥐',
  '🥑',
  '🥒',
  '🥓',
  '🥔',
  '🥕',
  '🥖',
  '🥗',
  '🥘',
  '🥙',
  '🥚',
  '🥛',
  '🥜',
  '🥝',
  '🥞',
  '🦀',
  '🦁',
  '🦂',
  '🦃',
  '🦄',
  '🦅',
  '🦆',
  '🦇',
  '🦈',
  '🦉',
  '🦊',
  '🦋',
  '🦌',
  '🦍',
  '🦎',
  '🦏',
  '🦐',
  '🦑',
  '🧀',
  '‼',
  '⁉',
  '™',
  'ℹ',
  '↔',
  '↕',
  '↖',
  '↗',
  '↘',
  '↙',
  '↩',
  '↪',
  '#⃣',
  '⌚',
  '⌛',
  '⌨',
  '⏏',
  '⏩',
  '⏪',
  '⏫',
  '⏬',
  '⏭',
  '⏮',
  '⏯',
  '⏰',
  '⏱',
  '⏲',
  '⏳',
  '⏸',
  '⏹',
  '⏺',
  'Ⓜ',
  '▪',
  '▫',
  '▶',
  '◀',
  '◻',
  '◼',
  '◽',
  '◾',
  '☀',
  '☁',
  '☂',
  '☃',
  '☄',
  '☎',
  '☑',
  '☔',
  '☕',
  '☘',
  '☝🏻',
  '☝🏼',
  '☝🏽',
  '☝🏾',
  '☝🏿',
  '☝',
  '☠',
  '☢',
  '☣',
  '☦',
  '☪',
  '☮',
  '☯',
  '☸',
  '☹',
  '☺',
  '♀',
  '♂',
  '♈',
  '♉',
  '♊',
  '♋',
  '♌',
  '♍',
  '♎',
  '♏',
  '♐',
  '♑',
  '♒',
  '♓',
  '♠',
  '♣',
  '♥',
  '♦',
  '♨',
  '♻',
  '♿',
  '⚒',
  '⚓',
  '⚔',
  '⚕',
  '⚖',
  '⚗',
  '⚙',
  '⚛',
  '⚜',
  '⚠',
  '⚡',
  '⚪',
  '⚫',
  '⚰',
  '⚱',
  '⚽',
  '⚾',
  '⛄',
  '⛅',
  '⛈',
  '⛎',
  '⛏',
  '⛑',
  '⛓',
  '⛔',
  '⛩',
  '⛪',
  '⛰',
  '⛱',
  '⛲',
  '⛳',
  '⛴',
  '⛵',
  '⛷🏻',
  '⛷🏼',
  '⛷🏽',
  '⛷🏾',
  '⛷🏿',
  '⛷',
  '⛸',
  '⛹🏻‍♀️',
  '⛹🏻‍♂️',
  '⛹🏻',
  '⛹🏼‍♀️',
  '⛹🏼‍♂️',
  '⛹🏼',
  '⛹🏽‍♀️',
  '⛹🏽‍♂️',
  '⛹🏽',
  '⛹🏾‍♀️',
  '⛹🏾‍♂️',
  '⛹🏾',
  '⛹🏿‍♀️',
  '⛹🏿‍♂️',
  '⛹🏿',
  '⛹️‍♀️',
  '⛹️‍♂️',
  '⛹',
  '⛺',
  '⛽',
  '✂',
  '✅',
  '✈',
  '✉',
  '✊🏻',
  '✊🏼',
  '✊🏽',
  '✊🏾',
  '✊🏿',
  '✊',
  '✋🏻',
  '✋🏼',
  '✋🏽',
  '✋🏾',
  '✋🏿',
  '✋',
  '✌🏻',
  '✌🏼',
  '✌🏽',
  '✌🏾',
  '✌🏿',
  '✌',
  '✍🏻',
  '✍🏼',
  '✍🏽',
  '✍🏾',
  '✍🏿',
  '✍',
  '✏',
  '✒',
  '✔',
  '✖',
  '✝',
  '✡',
  '✨',
  '✳',
  '✴',
  '❄',
  '❇',
  '❌',
  '❎',
  '❓',
  '❔',
  '❕',
  '❗',
  '❣',
  '❤',
  '➕',
  '➖',
  '➗',
  '➡',
  '➰',
  '➿',
  '⤴',
  '⤵',
  '*⃣',
  '⬅',
  '⬆',
  '⬇',
  '⬛',
  '⬜',
  '⭐',
  '⭕',
  '0⃣',
  '〰',
  '〽',
  '1⃣',
  '2⃣',
  '㊗',
  '㊙',
  '3⃣',
  '4⃣',
  '5⃣',
  '6⃣',
  '7⃣',
  '8⃣',
  '9⃣',
  '©',
  '®',
  ''
]



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/emojiNative.js